import { Component, instantiate, Node, Prefab, _decorator } from 'cc';
import MultiThemeSource from '../../../../common/scripts/Toolkit/Components/MultiTheme/MultiThemeSource';
import Dropdown from '../../../../common/scripts/Toolkit/Components/Dropdown/Dropdown';

export enum GameTagOption {
    All = 'all',
    Favorite = 'favorite',
}

type IGameTagOptionContentPrefabMap = {
    [value in GameTagOption]: Prefab;
};

const { ccclass, property, requireComponent } = _decorator;

@ccclass('GameTagOptionContentPrefabMap')
class GameTagOptionContentPrefabMap implements IGameTagOptionContentPrefabMap {
    @property(Prefab)
    public readonly all: Prefab = null;

    @property(Prefab)
    public readonly favorite: Prefab = null;
}

@ccclass('GameTagFilterDropdown')
@requireComponent(Dropdown)
export default class GameTagFilterDropdown extends Component {
    @property(GameTagOptionContentPrefabMap)
    private readonly gameTagOptionContentPrefabMap: GameTagOptionContentPrefabMap = null;

    private _dropdown: Dropdown<GameTagOption> = null;
    private _displayOptionContentMap: { [value in GameTagOption]?: Node } = {};

    private get dropdown() {
        if (!this._dropdown) {
            this._dropdown = this.getComponent(Dropdown) as Dropdown<GameTagOption>;
        }
        return this._dropdown;
    }

    protected onLoad() {
        this.dropdown.init(
            [GameTagOption.All, GameTagOption.Favorite] as Readonly<GameTagOption[]>,
            (displayName, selectedOption) => {
                // Hide all option content
                Object.values(this._displayOptionContentMap).forEach((node) => {
                    node.active = false;
                });
                // Show selected option content
                if (!this._displayOptionContentMap[selectedOption]) {
                    const optionContent = this._generateOptionContent(selectedOption, true);
                    this._displayOptionContentMap[selectedOption] = optionContent;
                    displayName.addChild(optionContent);
                } else {
                    this._displayOptionContentMap[selectedOption].active = true;
                }
            },
            (node, option) => node.addChild(this._generateOptionContent(option, false)),
        );
    }

    private _generateOptionContent(option: GameTagOption, useAsDisplayName: boolean): Node {
        const optionContentPrefab = this.gameTagOptionContentPrefabMap[option];
        if (!optionContentPrefab) {
            throw new Error(`Cannot find content prefab for option: ${option}`);
        }
        const optionContent = instantiate(optionContentPrefab);
        optionContent.getComponent(MultiThemeSource).theme = useAsDisplayName ? 1 : 0;
        return optionContent;
    }
}
